var map = {
	"./ashford.svg": 896,
	"./bedford.svg": 897,
	"./breckland.svg": 898,
	"./cardiff.svg": 899,
	"./darlington.svg": 900,
	"./demo.svg": 901,
	"./hfh.svg": 902,
	"./hull.svg": 903,
	"./kirklees.svg": 904,
	"./leicester.svg": 905,
	"./northgate.svg": 906,
	"./preston.svg": 907,
	"./rushcliffe.svg": 908,
	"./selby.svg": 909,
	"./sholland.svg": 910,
	"./slough.svg": 911,
	"./telford.svg": 912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 895;